import { EProductPriority } from 'constants/enums';

export const TRANSLATE_MOCK_MAP: Record<string, string> = {
  'footer.privacyPolicy': 'Privacy Policy',
  'footer.termsAndConditions': 'Terms and Conditions',
  'footer.support': 'Support',
  'footer.appstore': 'App Store',
  'footer.googleplay': 'Google Play'
};

export const PRODUCT_PRIORITY_OPTIONS = Object.values(EProductPriority).map(
  (priority) => ({
    value: priority,
    label: priority
  })
);
